export const TranslationIdMap = '';

export const TranslationKeyMap = {
    '_48_MANAGER': 'Manager',
    '_64_SITE': 'Site',
    '_67_SUPERGROUP': 'SuperGroup',
    '_102_USER_NAME': 'User Name',
    '_127_STATUS': 'Status',
    '_536_SCORECARD': 'Scorecard',
    '_711_NO_DATA_AVAILABLE': 'No Data Available',
    '_752_SCORE': 'Score',
    '_773_PERIOD': 'Period',
    '_777_RANK': 'Rank',
    '_962_OVERALL_SCORE': 'Overall Score',
    '_7146_METRIC_NAME': 'Metric Name',
    '_725_ACTUAL': 'Actual',
    '_726_TARGET': 'Target',
    '_768___TO_TARGET': '% to Target',
    '_9250_FROM': 'from',
    '_9251_MY': 'My',
    '_9252_PUBLISHED_SCORECARDS': 'Published Scorecards',
    '_9253_TO': 'to',
    '_9254_UNPUBLISHED_SCORECARDS': 'Unpublished Scorecards',
    '_9255_PILLAR': 'Pillar',
    '_9256_WEIGHT': 'Weight',
    '_9257_ORIGINAL_POINTS': 'Original Points',
    '_9258_ADJUSTED_POINTS': 'Adjusted Points',
    '_9259_METRIC_SCORE': 'Metric Score',
    '_9260_METRIC_RANK': 'Metric Rank',
    '_9261_POINTS_BAND': 'Points Band',
    '_9262_N_TILE': 'N-Tile',
    '_9263_N_TILE_BAND': 'N-Tile Band',
    '_9264_ACTUAL_TYPE': 'Actual Type',
    '_9265_TARGET_TYPE': 'Target Type',
    '_9266_PERCENT_TYPE': 'Percent Type',
    '_9267_SCORING_TYPE': 'Scoring Type',
    '_9268_ACTUAL_TREND': 'Actual Trend',
    '_9269___TO_TARGET_TREND': '% to Target Trend',
    '_9270_COACHING_PLAN_ACTIVE': 'Coaching Plan Active',
    '_9271_METRIC_LABEL': 'Metric Label',
    '_9272_PILLAR_DESCRIPTION': 'TBD',
    '_9273_METRIC_NAME_DESCRIPTION': 'TBD',
    '_9274_ACTUAL_DESCRIPTION': 'Results achieved for the Scorecard period',
    '_9275_TARGET_DESCRIPTION': 'Metric Target for the Scorecard period',
    '_9276_TO_TARGET_DESCRIPTION': '[Actual]/[Target] * 100%',
    '_9277_WEIGHT_DESCRIPTION': 'Configured weight of the metric',
    '_9278_ORIGINAL_POINTS_DESCRIPTION': 'Points earned by metric',
    '_9279_ADJUSTED_POINTS_DESCRIPTION': 'Points earned by metric after any conditions that affect metric scores',
    '_9280_METRIC_SCORE_DESCRIPTION': '[Adjusted Points]*[Weight]',
    '_9281_METRIC_RANK_DESCRIPTION': 'TBD',
    '_9282_POINTS_BAND_DESCRIPTION': 'TBD',
    '_9283_N_TILE_DESCRIPTION': 'TBD',
    '_9284_N_TILE_BAND_DESCRIPTION': 'Performance N-Tile where user results fell',
    '_9285_ACTUAL_TYPE_DESCRIPTION': 'Calculation method for actual',
    '_9286_TARGET_TYPE_DESCRIPTION': 'Calculation method for target',
    '_9287_PERCENT_TYPE_DESCRIPTION': 'Calculation is done using % to Target or Variance',
    '_9288_SCORING_TYPE_DESCRIPTION': 'How Score of metric is determined: Banding/Raw, Percent/Banding by Actuals',
    '_9289_ACTUAL_TREND_DESCRIPTION': '(Current Actual Value - Previous Period Actual Value)/ Previous Period Actual Value * 100',
    '_9290_TO_TARGET_TREND_DESCRIPTION': '[Current % To Target value] - [Previous Period % To Target Value]',
    '_9291_COACHING_PLAN_ACTIVE_DESCRIPTION': 'TBD',
    '_9292_METRIC_LABEL_DESCRIPTION': 'TBD',
    '_9293_PERIOD_TYPE': 'Period Type',
    '_9294_SHOW_HIDE_SUPERGROUPS': 'Show/Hide SuperGroups',
    '_9295_MY_SCORECARDS': 'My Scorecards',
    '_9296_ADD_SCORECARDS': 'Add Scorecards',
    '_9297_YES': 'Yes',
    '_9298_NO': 'No',
    '_9299_COMPACT_VIEW': 'Compact View',
    '_9300_WIDE_VIEW': 'Wide View',
    '_9301_COMPENSATION_DESCRIPTION': 'Description',
    '_9302_COMPENSATION_CURRENT_VALUE': 'Current Value',
    '_9303_COMPENSATION_IN_EFFECT': 'In Effect',
    '_9304_COMPENSATION_QUALIFIER_MET': 'Qualifier Met',
    '_9305_ALL_QUALIFIERS_MET': 'All Qualifiers Met',
    '_9306_BASE_BONUS': 'Base Bonus',
    '_9307_MODIFIERS': 'Modifiers',
    '_9308_ESTIMATED_PAYOUT': 'Estimated Payout',
    '_9350_THIS_USER_S_SCORECARDS_ARE_BEING_PRESENTED_FOR_THE_FIRST_TIME__PLEASE_WAIT_': 'Looks like this user\'s scorecards are being presented for the first time, please wait',
    '_9351_SCORECARD_ID': 'Scorecard ID',
    '_9352_SCORECARD_STATUS': 'Scorecard Status',
    '_9354_MANAGER_SCORECARD': 'Performance Scorecard',
    '_9355_PERFORMANCE_SCORECARD': 'Performance Scorecard',
    '_9357_MY_NUMBER_OF_ACTIVE_DAYS': 'My Number of Active Days',
    '_9358_CURRENT_SCORECARD_PERIOD': 'Current Scorecard Period',
    '_9359_EXPORT_AS_PDF': 'Export as PDF',
    '_9360_ORIGINAL_SCORE': 'Original Score',
    '_9361_ADJUSTED_SCORE': 'Adjusted Score',
    '_9362_WEIGHTED_SCORE': 'Weighted Score',
    '_9363_NTILE_POINTS': 'NTile Points',
    '_9367_USE_LIVE_DATA': 'Use Live Data',
    '_9368_ID': 'ID',
    '_9384_BASE_BONUS_WHEN_TOTAL_SCORE_FROM': 'When Total Score From',
    '_9385_BASE_BONUS_VARIABLE_PAY_BASE_BONUS_IS': 'Variable Pay Base Bonus is',
    '_9386_VARIABLE_PAY_BASE_BONUS_GRID': 'Variable Pay Base Bonus Grid',
    '_9387_BASE_BONUS_DETAIL_': 'Base Bonus Detail',
    '_9388_GENERATED_ON': 'Generated On',
    '_9389_NOT_ENOUGH_CALLS_CHATS_HANDLED': 'Not enough calls/chats handled',
    '_9390_VERY_FEW_PEERS_IN_GROUP': 'Very few peers in group',
    '_9391_EXPORT_DATA': 'Export Data',
    '_9395_RESET_GRID': 'Reset Grid',
    '_9392_RANK_VIEW': 'Rank View',
    '_9393_DIRECT_REPORT_SCORECARDS': 'Direct Report Scorecards',
    '_9394_CONTRIBUTION_VIEW': 'Contribution View',
    '_763_CLOSE_MODAL_': 'Close',
    '_9396_COLLAPSE_ALL_': 'Collapse All',
    '_9402_NA': 'NA',
    '_9403_PREVIOUS_SCORECARD_NOT_AVAILABLE_FOR_COMPARE': 'Previous Scorecard not available for compare',
    '_9404_SCORE_TREND': 'Score Trend:',
    '_9397_EXPAND_ALL_': 'Expand all',
    '_9889_NAME_SCORECARD': '{{name}}ʼs Scorecard',
    '_9890_RETURN_TO_PULSE': 'Return to Pulse',
    '_9891_NO_MORE_TABS_CAN_BE_ADDED': 'No more tabs can be added',
    '_9113_PUBLISHED': 'Published',
    '_9114_UNPUBLISHED': 'Unpublished',
    '_9116_DIRECTREPORTS_DESCRIPTION': 'Users who reported to Manager in selected Period',
    '_9117_SUPERGROUP_DESCRIPTION': 'SuperGroup associated to user\'s scorecard',
    '_9118_PERIOD_DESCRIPTION': 'Start and end dates associated to user\'s scorecard',
    '_9119_OVERALL_SCORE_DESCRIPTION': 'Score achieved on the scorecard',
    '_9120_SUPERGROUP_OVERALL_RANK_DESCRIPTION': 'Ranking of Overall Score within user\'s SuperGroup',
    '_9121_SITE_SUPERGROUP_RANK_DESCRIPTION': 'Ranking of Overall Score within user\'s site and SuperGroup',
    '_9122_ROLE_OVERALL_RANK_DESCRIPTION': 'Ranking of Overall Score within user\'s role',
    '_9123_ROLE_BY_REGION_RANK_DESCRIPTION': 'Ranking of Overall Score within user\'s role and region',
    '_9124_SUPERGROUP_OVERALL_RANK': 'SuperGroup Overall Rank',
    '_9125_SITE_SUPERGROUP_RANK': 'Site/SuperGroup Rank',
    '_9126_ROLE_OVERALL_RANK': 'Role Overall Rank',
    '_9127_ROLE_BY_REGION_RANK': 'Role by Region Rank',
    '_9128_DIRECTREPORTS': 'Direct Reports',
    '_9365_FYI': 'FYI',
    '_9371_CONDITIONS': 'Conditions',
    '_9370_QUALIFIERS': 'Qualifiers',
    '_9374_IN_EFFECT': 'In effect',
    '_804_SUPERGROUP_': 'SuperGroup:',
    '_9892_SCORECARD_GRID': 'Scorecard Grid',
    '_9893_DIRECT_REPORT_VIEW': 'Direct Report View',
    '_9894_FYI_METRICS': 'FYI Metrics',
    '_9895_CONDITION_METRICS': 'Condition Metrics',
    '_9896_MODIFIER_METRICS': 'Modifier Metrics',
    '_9897_QUALIFIER_METRICS': 'Qualifier Metrics',
    '_9898_WEIGHTED_METRICS': 'Weighted Metrics',
    '_9405_CURRENT_': 'Current:',
    '_9406_PREVIOUS_': 'Previous:',
    '_7360_FILTER': 'Filter',
    '_9864_APPLY_FILTER': 'Apply Filter',
    '_9880_MI2_SCORECARD_CATEGORY': 'MI2 Scorecard Category',
    '_9899_PEER_GROUP_OVERALL_RANK': 'PeerGroup Overall Rank',
    '_9900_LOB_OVERALL_RANK': 'LOB Overall Rank',
    '_9901_PEER_GROUP_OVERALL_RANK_DESCRIPTION': 'Ranking of Overall Score within userʼs PeerGroup',
    '_9902_LOB_OVERALL_RANK_DESCRIPTION': 'Ranking of Overall Score within userʼs LOB',
    '_9977_EXPAND': 'Expand',
    '_9978_COLLAPSE': 'Collapse',
    '_9979_FILTER_GRID': 'Filter Grid',
    '_9980_LAUNCH_SCORECARD': 'Launch Scorecard'
};
